export enum CabinClassCode {
  Business = "BUSINESS",
  Economy = "ECONOMY",
  First = "FIRST",
  NoPreference = "NO_PREFERENCE",
  PremiumEconomy = "PREMIUM_ECONOMY",
  PremiumFirst = "PREMIUM_FIRST",
}
